"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BannerVideo = /** @class */ (function () {
    function BannerVideo(documentObject) {
        var that = this;
        var youtubeElements = documentObject.querySelectorAll('.c-banner--youtube');
        var videoElements = documentObject.querySelectorAll('.c-banner--video');
        if (youtubeElements.length > 0 && !that.doesYoutubeApiExist()) {
            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
        setTimeout(function () {
            // TODO: fix this event (window as { [key: string]: any })['onYouTubeIframeAPIReady'] = () => {
            var YT = window['YT'];
            if (YT !== null && YT !== undefined) {
                youtubeElements.forEach(function (element) {
                    var isBannerVisible = true;
                    var videoId = element.dataset.video;
                    var player = new YT.Player('video' + videoId, {
                        height: '390',
                        width: '640',
                        videoId: videoId,
                        playerVars: { 'autoplay': 1, 'controls': 0, 'mute': 1, 'loop': 1, 'modestbranding': 1, 'enablejsapi': 1, 'rel': 0, 'showinfo': 0 },
                        events: {
                            'onStateChange': onPlayerStateChange,
                            'onReady': onPlayerReady
                        }
                    });
                    function onPlayerStateChange(event) {
                        if (event.data === YT.PlayerState.ENDED) {
                            player.seekTo(1, false);
                            player.playVideo();
                        }
                    }
                    function onPlayerReady(event) {
                        var isVisible = that.isScrolledIntoView(element);
                        if (!element.closest('.c-carousel__slide')) {
                            if (isVisible) {
                                player.playVideo();
                                isBannerVisible = true;
                            }
                            else if (!isVisible) {
                                player.pauseVideo();
                                isBannerVisible = false;
                            }
                            window.addEventListener('scroll', function (e) {
                                isVisible = that.isScrolledIntoView(element);
                                if (isVisible && !isBannerVisible) {
                                    player.playVideo();
                                    isBannerVisible = true;
                                }
                                else if (!isVisible && isBannerVisible) {
                                    player.pauseVideo();
                                    isBannerVisible = false;
                                }
                            });
                        }
                    }
                    that.setIframeSize(element);
                });
            }
        }, 1000);
        videoElements.forEach(function (element) {
            var isBannerVisible = true;
            var isVisible = that.isScrolledIntoView(element);
            var videoElem = element.querySelector('.c-banner__background-video');
            if (!element.closest('.c-carousel__slide')) {
                if (isVisible) {
                    isBannerVisible = true;
                    try {
                        videoElem.play();
                    }
                    catch (ex) {
                        // Could not play video
                    }
                }
                else if (!isVisible) {
                    isBannerVisible = false;
                    try {
                        videoElem.pause();
                    }
                    catch (ex) {
                        // Could not pause video
                    }
                }
                window.addEventListener('scroll', function (e) {
                    isVisible = that.isScrolledIntoView(element);
                    if (isVisible && !isBannerVisible) {
                        isBannerVisible = true;
                        try {
                            videoElem.play();
                        }
                        catch (ex) {
                            // Could not play video
                        }
                    }
                    else if (!isVisible && isBannerVisible) {
                        isBannerVisible = false;
                        try {
                            videoElem.pause();
                        }
                        catch (ex) {
                            // Could not pause video
                        }
                    }
                });
            }
        });
    }
    BannerVideo.prototype.isScrolledIntoView = function (element) {
        var position = element.getBoundingClientRect();
        if (position.top < window.innerHeight && position.bottom >= 0) {
            return true;
        }
        else {
            return false;
        }
    };
    BannerVideo.prototype.doesYoutubeApiExist = function () {
        var url = "https://www.youtube.com/iframe_api";
        var scripts = document.getElementsByTagName('script');
        for (var i = scripts.length; i--;) {
            if (scripts[i].src == url)
                return true;
        }
        return false;
    };
    BannerVideo.prototype.setIframeSize = function (element) {
        var iframe = element.querySelector('iframe');
        if (iframe) {
            iframe.style.height = element.clientWidth * 0.5625 + 'px';
            iframe.style.width = '100%';
            iframe.style.left = '0';
            iframe.style.top = (element.clientHeight - element.clientWidth * 0.5625) / 2 + 'px';
            if (element.clientWidth * 0.5625 < element.clientHeight) {
                iframe.style.height = '100%';
                iframe.style.width = 'calc(100% + ' + (element.clientHeight - element.clientWidth * 0.5625) * 2 + 'px)';
                iframe.style.left = '-' + (element.clientHeight - element.clientWidth * 0.5625) + 'px';
                iframe.style.top = '0';
            }
            window.addEventListener('resize', function (e) {
                iframe.style.height = element.clientWidth * 0.5625 + 'px';
                iframe.style.width = '100%';
                iframe.style.left = '0';
                iframe.style.top = (element.clientHeight - element.clientWidth * 0.5625) / 2 + 'px';
                if (element.clientWidth * 0.5625 < element.clientHeight) {
                    iframe.style.height = '100%';
                    iframe.style.width = 'calc(100% + ' + (element.clientHeight - element.clientWidth * 0.5625) * 2 + 'px)';
                    iframe.style.left = '-' + (element.clientHeight - element.clientWidth * 0.5625) + 'px';
                    iframe.style.top = '0';
                }
            });
        }
    };
    return BannerVideo;
}());
exports.default = BannerVideo;
